import { useContext, useEffect } from "react";
import "./App.scss";
import NavHeader from "./components/Header/NavHeader";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoute from "./routes/AppRoute";
import { Watch } from "react-loader-spinner";
import { AdminContext, AdminProvider } from "./context/AdminContext";
import Footer from "./components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserAccount } from "./redux/slice/userSlice";

function App() {
  const admin = useSelector(state => state.admin)
  useEffect(() => {
    let session = sessionStorage.getItem('account')
    if (session) {
      setAccount(JSON.parse(session))
    }
  }, [])
  const dispatch = useDispatch()


  useEffect(() => {
    dispatch(fetchUserAccount())
  }, [])
  return (
    <BrowserRouter>
      {admin && admin.isLoading ? (
        <div className="loading-container d-flex justify-content-center">
          <Watch
            visible={true}
            height="80"
            width="80"
            radius="48"
            color="#000"
            ariaLabel="watch-loading"
          />
          <div>Loading data...</div>
        </div>
      ) : (
        <>
          <div className="app-header">
            <NavHeader />
          </div>
          <div className="app-container">
            <AppRoute />
          </div>
          <Footer />
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </BrowserRouter>
  );
}

export default App;
